"use client";

import { Bell, ChevronRight, Loader2Icon, Repeat } from "lucide-react";
import { SetStateAction, useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { NotificationType } from "@/react-queries/queries/notifications/types";
import { useApiGet, useApiSend } from "@/react-queries/custom-request";
import { useUser } from "@/zustand-hooks/user-hook";
import { getAllNotifications } from "@/react-queries/queries/notifications";
import { Link } from "@/i18n/routing";
// import { useSocket } from "@/providers/SocketProvider";
import { useLocale, useTranslations } from "next-intl";
import NotificationItem from "./NotificationItem";


const NotificationsMobile = ({ setNotification }: { setNotification: React.Dispatch<SetStateAction<NotificationType | undefined>> }) => {
    const locale = useLocale();
    // const { socket } = useSocket();
    const user = useUser(s => s.user);
    const [isOpened, setIsOpened] = useState(false);
    const translate = useTranslations('Header.notifications');
    const translate_empties = useTranslations('empties');
    // @ts-ignore
    const { data, isLoading, isError, refetch } = useApiGet<{ notifications: NotificationType[] }>(['notifications', user?.id], getAllNotifications);
    /* 
    
    
        useEffect(() => {
            socket.on('notification', () => refetch());
            return () => { socket.off('notification') };
        }, []);
     */
    return (
        <div className={'transition-transform overflow-hidden rounded-sm w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-none'}>
            <div className={cn("flex flex-col gap-4 font-bold p-4", isOpened && 'border-b border-slate-200 dark:border-slate-500')} onClick={() => setIsOpened(!isOpened)}>
                <div className="flex items-center justify-between">
                    <p className="flex gap-2 items-center text-black dark:text-white">
                        <Bell />
                        {translate('title')}
                        {
                            // @ts-ignore
                            data?.notifications &&
                                // @ts-ignore
                                data?.notifications.length > 0 &&
                                // @ts-ignore
                                data?.notifications.filter(n => !n.view).length > 0 ?
                                // @ts-ignore
                                <span className="bg-red-700 text-xs font-bold rounded-full text-white px-2">{data?.notifications.filter(n => !n.view).length > 99 ? '99+' : data?.notifications.filter(n => !n.view).length}</span>
                                : null
                        }
                    </p>
                    <ChevronRight className={cn('transition-transform', isOpened ? 'rotate-90' : 'rotate-0')} />
                </div>
            </div>
            {
                isOpened &&
                <>
                    <div className="dark:even:[&>div]:bg-slate-600 even:[&>div]:bg-slate-50 max-h-[150px] overflow-y-auto scrollbar" onClick={(e) => e.stopPropagation()}>
                        {
                            // @ts-ignore
                            data?.notifications &&
                                // @ts-ignore
                                data?.notifications.length > 0 &&
                                // @ts-ignore
                                data?.notifications.filter(n => !n.view).length > 0 ?
                                // @ts-ignore
                                data?.notifications.filter(n => !n.view).map((item, i) => (
                                    <div key={`${item.date}-${item.title}-${i}`} className="cursor-pointer hover:opacity-90">
                                        <NotificationItem item={item} locale={locale} setNotification={setNotification} />
                                    </div>
                                ))
                                : isError ?
                                    <div className="!bg-red-400 bg-opacity-25 text-red-700 dark:text-white flex items-center p-4 text-xs gap-2">
                                        An error occured while getting notifications
                                        <button
                                            disabled={isLoading}
                                            className="bg-red-700 text-white rounded-sm shrink-0 p-2 flex items-center gap-2"
                                            onClick={() => refetch()}
                                        >
                                            {
                                                isLoading ? <Loader2Icon width={15} height={15} className="shrink-0 animate-spin" /> : <>Try again<Repeat width={15} height={15} className="shrink-0" /></>
                                            }
                                        </button>
                                    </div>
                                    : <div className="w-full p-4 text-center">{translate_empties('notifications')}</div>
                        }
                    </div>
                    <div className="flex items-center justify-center border-t border-slate-200 dark:border-slate-500 p-4" onClick={(e) => e.stopPropagation()}>
                        <Link
                            onClick={() => setIsOpened(false)}
                            className="hover:bg-opacity-70 transition-colors rounded-sm text-sm p-2 bg-[#405189] text-white w-full text-center"
                            href={'/notifications'}>
                            {translate('buttons.view_all')}
                        </Link>
                    </div>
                </>
            }
        </div>

    );
};

export default NotificationsMobile;
